export default {
  label: 'Enviar a',
  counter: '{{current}} de {{max}}',
  default_badge: 'Predeterminado',
  remove: 'Quitar {{email}}',
  add_back: 'Volver a añadir',
  empty: 'Añade al menos un correo electrónico.',
  add_label: 'Añadir un correo electrónico',
  placeholder: 'nombre@ejemplo.com',
  add: 'Añadir',
  hint: 'Hasta {{max}} correos electrónicos. Cada uno recibe su propio correo.',
  hint_full: 'Es el máximo que admite esta lista. Quita un correo para añadir otro.',
  errors: {
    full: 'Puedes añadir como máximo {{max}} correos electrónicos.',
    invalid: 'Introduce un correo como nombre@ejemplo.com.',
    duplicate: '{{email}} ya está en la lista.',
  },
};
